import { render, staticRenderFns } from "./Consumer.vue?vue&type=template&id=2bc9b545&"
import script from "./Consumer.vue?vue&type=script&lang=js&"
export * from "./Consumer.vue?vue&type=script&lang=js&"
import style0 from "./Consumer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports